'use client';

import  './VehicleCard.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCirclePlay, faCamera, faStar as fasStar } from '@fortawesome/free-solid-svg-icons';
import { faStar as farStar } from '@fortawesome/free-regular-svg-icons';

interface VehicleCardProps {
  [key: string]: any;
}


export default function VehicleCard(vehicle: VehicleCardProps) {

const isFavorited = false;

    return (
        <>
        <li>
        <div className="node-used-vehicle l-node-used-vehicle--search-result view-mode-search_result">


            <div className="l-node-used-vehicle--search-result__flex-wrap">
            <div className="l-node-used-vehicle--search-result__photo">
                <div className="l-node-used-vehicle--search-result__photo-inner">
                <a href={vehicle.ad_details_path}>
                    <div className="l-node-used-vehicle--search-result__photo-overlay">
                    <div className="l-node-used-vehicle--search-result__photo-count">
                        <div className="field-name-photo-count"><FontAwesomeIcon icon={faCamera} className="fa-fw" /> {vehicle.imageCount}</div>
                    </div>
                    {vehicle.youtube_link && (
                        <div className="l-node-used-vehicle--search-result__youtube"><div className="field field-name-youtube"><FontAwesomeIcon icon={faCirclePlay} className="fa-fw" /> Video</div></div>
                    )}
                    {vehicle.vehicle_sash && (
                        <div className="l-node-used-vehicle--search-result__sash"><div className="field-name-field-sash">{vehicle.vehicle_sash}</div></div>
                    )}
                    </div>
                </a>
                <div className="l-node-used-vehicle--search-result__photo-mobile">
         
                    <div className="compare-mobile"><div className="compare-button button mobile-only carlist" data-vehid={vehicle.id}><FontAwesomeIcon icon={isFavorited ? fasStar : farStar} className="fa-fa" /><span></span></div></div>
             
                </div>
                    <a href={vehicle.ad_details_path}>
                    <div className="field-name-field-field-vehicle-photos">
                        {vehicle.images && vehicle.images.length > 0 && vehicle.images[0] && vehicle.images[0].i800x600 && (
                        <img
                            src={vehicle.images[0].i800x600}
                            alt={vehicle.images[0].alt || 'Vehicle Image'}
                            className="main-img"
                              onError={(e) => {
                                const target = e.currentTarget as HTMLImageElement;
                                target.onerror = null; // prevent infinite loop
                                target.src = '/media/placeholder.jpg'; // path to your fallback image
                            }}
                        />
                        )}
                    </div>
                    <div className="l-node-used-vehicle--search-result__overlay">
                        <div className="field field-name-overlay">
                        <i className="far fa-eye"></i> Discover
                        </div>
                    </div>
                    </a>
                
                </div>
            </div>



            <div className="l-node-used-vehicle--search-result__main-content">
                <div className="l-node-used-vehicle--search-result__main-content--inner">

                <div className="l-node-used-vehicle--search-result__title-wrap">
                    <div className="l-node-used-vehicle--search-result__logo">
                    <img src={`https://s3.eu-west-1.amazonaws.com/processed-files.autopromotor.co.uk/shared/manufacturer-logos/${vehicle.manufacturer}_light.png`} data-placeholder="" alt={vehicle.manufacturer_display} />
                    </div>
                    <div className="l-node-used-vehicle--search-result__title">
                    <a href={vehicle.ad_details_path}>
                        <div className="field-name-title">
                        <h3>
                            {vehicle.vehicle_type === 'caravan' && (
                                <>
                                {vehicle.year_built}
                                {vehicle.show_reg_letter && ` ${vehicle.reg_letter}`}
                                {' '}
                                </>
                            )}
                            {vehicle.manufacturer_display} {vehicle.model_display}
                        </h3>
                        </div>
                        <div className="field-name-derivative">
                        {vehicle.derivative_display}
                        </div>
                    </a>
                    </div>
                </div>
                
                <div className="l-node-used-vehicle--search-result__spec">
                <ul className="specs-list">
                    {/* {{ partial "vehicle-listings/overview-fields.html" . }} */}
                </ul>
                </div>


                {/* {{ if gt (len $.Site.Data.dealerinfo.branches) 1 }} */}
                <div className="l-node-used-vehicle--search-result__branch">
                    <div className="field field-name-branch">
                    <i className="fas fa-map-marker-alt"></i> Available at <span>{vehicle.branch_name}</span>
                    </div>
                </div>
                {/* {{ end }} */}

                </div>



                <div className="l-node-used-vehicle--search-result__footer">
                <a href={vehicle.ad_details_path} className="l-node-used-vehicle--search-result__price">
                    <div>

                        {vehicle.sold ? (
                            <div className="field-name-field-vehicle-price">Sold</div>
                        ) : (
                            <>
                            <div className="field-name-field-vehicle-price">£{vehicle.price.toLocaleString()}</div>
                            {vehicle.vat_exempt && <div className='field-name-field-vehicle-vat'>No VAT</div>}
                            {vehicle.vat_excluded && <div className='field-name-field-vehicle-vat'>+ VAT</div>}
                            {vehicle.admin_fee && <div className="field-name-admin-fee"><div className="label-inline">+ admin fee of</div> <div className="value">£{vehicle.admin_fee.toLocaleString()}</div></div>}
                            {vehicle.list_price && <div className="field-name-list-price"><div className="label-inline">Was</div><div className="value">£{vehicle.list_price.toLocaleString()}</div></div>}
                            {vehicle.list_price && vehicle.price && vehicle.list_price > vehicle.price && (
                                <div className="field-name-discount">
                                    <div className="label-inline">Saving</div>{" "}
                                    <div className="value">
                                    £{(vehicle.list_price - vehicle.price).toLocaleString()}
                                    </div>
                                </div>
                                )}
                            </>
                        )}
         
                    
                    </div>
                </a>
                {/* {{ partial "finance_monthly_payment_list.html" .}} */}
                </div>

            

                <div className="l-node-used-vehicle--search-result__buttons">

                <div className="l-node-used-vehicle--search-result__sharing">
                    <div className="l-node-used-vehicle--search-result__social">
                    {/* {{ partial "social-sharing-listings.html" . }} */}
                    </div>

                    {/* {{ if eq $.Site.Params.saveandcompare.save_and_compare true }} */}
                    <div className="footer-button field-name-save-vehicle">
                        %vehicle_save%
                    </div>
                    {/* {{ end }} */}
                </div>


                <div className="l-node-used-vehicle--search-result__more-info">

                    <div className="more-info-buttons">
                    
                    {/* {{ partial "finance_listings_cta.html" . }} */}

                    <div className="footer-button field-name-more-information">
                        <a href={vehicle.ad_details_path} className="button">More Details</a>
                    </div>
                    </div>

                </div>
                </div>

                
            </div>

            </div>

            <a href={vehicle.ad_details_path}>
            <div className="l-node-used-vehicle--search-result__thumbs">
                %vehicle_thumbs%
            </div>
            </a>


            </div>

        </li>


        </>
    );
}